import Resource from './Resource';

export default class CovidSurvey extends Resource {
	constructor(options={}) {
		let {
			query = {}
		} = options;

		let route = 'covid-link';

		let config = {
			route: route,
			query: query
		};

		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
